// import {post} from '../utils/request';
import { wxConfig } from "./wxConfig";
import wx from "wx";

var wxfx = (options) => {
    var winUrl = window.location.href;
    if (winUrl.split("#")[0].indexOf("?") > -1) {
        window.location.href =
            winUrl.split("#")[0].split("?")[0] + window.location.hash;
        return;
    }
    wxConfig(
        {
            jsApiList: [
                // 必填，需要使用的JS接口列表
                "checkJsApi",
                "onMenuShareTimeline", //分享到微信朋友圈
                "onMenuShareAppMessage", //分享给微信朋友
            ],
            openTagList: ["wx-open-launch-weapp"],
        },
        (data) => {
            wx.ready(() => {
                wx.onMenuShareTimeline({
                    title: options.title, // 分享标题
                    link: options.url ? options.url : winUrl, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                    imgUrl: options.imgUrl, // 分享图标
                    success: function () {},
                    cancel: function () {},
                });
                wx.onMenuShareAppMessage({
                    title: options.title, // 分享标题
                    desc: options.desc, // 分享描述
                    link: options.url ? options.url : winUrl, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                    imgUrl: options.imgUrl, // 分享图标
                    type: "link", // 分享类型,[music、video或link，不填默认为link]
                    success: function () {},
                    cancel: function () {},
                });
            });
            wx.error(function (error) {
                // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
            });
        }
    );
};

export { wxfx };



// WEBPACK FOOTER //
// ./src/utils/wxfx.js